import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DRY_RUN } from '../contexts/dry-run.context';
import { ResourceDryRunApiResponse } from '@cms_root/app/modules/resources/models/api/resource-dry-run-api.model';

@Injectable()
export class DryRunInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isDryRunMode = req.context.get(DRY_RUN) === true;

    if (!isDryRunMode) {
      return next.handle(req);
    }

    const dryRunReq = req.clone({
      url: `${req.url}/dry_run`
    });

    return next.handle(dryRunReq).pipe(
      switchMap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const dryRunResult: ResourceDryRunApiResponse = event.body;

          if (!dryRunResult?.warnings?.length && (!dryRunResult?.errors || dryRunResult?.errors?.length === 0)) {
            const targetReq = req.clone({
              context: req.context.set(DRY_RUN, false)
            });
            return next.handle(targetReq);
          }
        }

        return of(event);
      })
    );
  }
}
